import HeroBackground from "./HeroBackground";

export default function Hero() {
  return (
    <section className="relative w-full px-8 md:px-12 pt-8 pb-16 overflow-hidden">
      {/* Layered background (grid + mosaic tiles + glow) */}
      <HeroBackground />

      {/* Grant recipient badge */}
      <div className="relative z-10 flex items-center justify-center gap-3 mb-6">
        <span className="text-sm text-neutral-600 whitespace-nowrap">
          Grant recipient from
        </span>
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-sun-line text-neutral-800"></i>
          </div>
          <span className="text-sm font-semibold tracking-widest text-neutral-800">
            SOLANA
          </span>
          <span className="text-[10px] font-medium tracking-widest text-neutral-500 ml-1">
            FOUNDATION
          </span>
        </div>
      </div>

      {/* Central visual spacer (hero image removed) */}
      <div className="relative w-full flex items-center justify-center">
        <div className="relative z-10 w-[520px] h-[440px]"></div>
      </div>

      {/* Bottom content row */}
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-6 mt-4 items-start">
        {/* Left column */}
        <div className="max-w-md">
          <h1 className="font-display text-5xl md:text-[56px] leading-[1.05] text-neutral-900 tracking-tight">
            AI Protocol <br />
            On Solana
          </h1>
          <p className="mt-6 text-base md:text-lg text-neutral-500 leading-relaxed">
            Symbiotic AI ecosystem for 1M+&nbsp; users.
          </p>
        </div>

        {/* Center CTA */}
        <div className="flex flex-col items-center justify-end pt-16">
          <a
            href="#"
            className="inline-flex items-center gap-2.5 bg-neutral-900 text-white text-base md:text-lg font-medium px-10 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-neutral-800 transition-colors"
          >
            <span>Start Now</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </a>

          {/* Small dot navigation / feature icons */}
          <div className="mt-10 flex items-center gap-6 text-neutral-400">
            <button className="w-6 h-6 flex items-center justify-center cursor-pointer hover:text-neutral-700 transition-colors">
              <i className="ri-apps-2-line text-base"></i>
            </button>
            <button className="w-6 h-6 flex items-center justify-center cursor-pointer hover:text-neutral-700 transition-colors">
              <i className="ri-shape-line text-base"></i>
            </button>
            <button className="w-6 h-6 flex items-center justify-center cursor-pointer hover:text-neutral-700 transition-colors">
              <i className="ri-stack-line text-base"></i>
            </button>
            <button className="w-6 h-6 flex items-center justify-center cursor-pointer hover:text-neutral-700 transition-colors">
              <i className="ri-fullscreen-line text-base"></i>
            </button>
          </div>
        </div>

        {/* Right column */}
        <div className="max-w-md lg:ml-auto lg:text-left">
          <h2 className="font-display text-5xl md:text-[56px] leading-[1.05] text-neutral-900 tracking-tight">
            AI Market
          </h2>
          <p className="mt-6 text-base md:text-lg text-neutral-500 leading-relaxed">
            Access modular AI app and ecosystem <br />
            products at a glance in one super-app.
          </p>
          <a
            href="#"
            className="inline-flex items-center gap-1.5 mt-6 text-base text-neutral-900 font-medium cursor-pointer group"
          >
            <span>More details</span>
            <div className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}